/*** IMPORTS FROM imports-loader ***/
var define = false;

export var Header = function () {

    return {
        //main function to initiate the module
        init: function () {
            //уменьшаем высоту headera при скроле

            smallOrLargeTopMenu();

            $(window).scroll(function () {
                smallOrLargeTopMenu();
            });

            function smallOrLargeTopMenu()
            {
                if ($(window).scrollTop() > 30) {
                    $(".header").addClass("header--small");
                    $(".button--header").addClass("button--header-small");
                    $(".testimonials-navigation").addClass("testimonials-navigation--small");
                }
                else{
                    $(".header").removeClass("header--small");
                    $(".button--header").removeClass("button--header-small");
                    $(".testimonials-navigation").removeClass("testimonials-navigation--small");
                }
            }

            //удаляем анимацию при загрузки страницы
            function delTransition(){
                $("body").removeClass("preload");
            }
            setTimeout(delTransition, 1000);

            //jQuery slow hide/show
            $.fn.slideFadeToggle = function(speed, easing, callback){
                return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
            };
        }

    };
}();



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/modules/Header.js